import { API_ROOT as API_BASE } from './environment'
export default {
  ACCOUNTS: API_BASE + '/accounts',
  ACCOUNTS_ID: API_BASE + '/accounts/{id}',
  ACCOUNTS_ID_CURRENCIES_ID: API_BASE + '/accounts/{accountId}/currencies/{currencyId}',
  BOOKINGS: API_BASE + '/bookings',
  BOOKINGS_ID: API_BASE + '/bookings/{id}',
  BOOKINGS_ID_ROOMS: API_BASE + '/bookings/{id}/rooms',
  BOOKINGS_ID_ROOMS_ID_ACCOUNTS_ID: API_BASE + '/bookings/{bookingId}/rooms/{roomId}/accounts/{accountId}',
  BOOKINGS_ID_GUESTS: API_BASE + '/bookings/{id}/guests',
  BOOKING_TYPES: API_BASE + '/booking-types',
  CURRENCIES: API_BASE + '/currencies',
  FACILITIES: API_BASE + '/facilities',
  FACILITIES_ID: API_BASE + '/facilities/{id}',
  GUESTS: API_BASE + '/guests',
  GUESTS_ID: API_BASE + '/guests/{id}',
  GUEST_CATEGORIES: API_BASE + '/guest-categories',
  GUEST_TYPES: API_BASE + '/guest-types',
  PROFILES: API_BASE + '/profiles',
  PROFILES_ID: API_BASE + '/profiles/{id}',
  PROFILE_CATEGORIES: API_BASE + '/profile-categories',
  PROFILE_TYPES: API_BASE + '/profile-types',
  ROOMS: API_BASE + '/rooms',
  TRANSACTIONS: API_BASE + '/transactions',
  TRANSACTIONS_ID: API_BASE + '/transactions/{id}'
}
